import { render, staticRenderFns } from "./msgEmailSent.vue?vue&type=template&id=2ef123c5&"
import script from "./msgEmailSent.vue?vue&type=script&lang=js&"
export * from "./msgEmailSent.vue?vue&type=script&lang=js&"
import style0 from "./msgEmailSent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports